<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DoaD04/tc-custom/9781607052029.jpg?1705238412954" alt="This image is the cover for the book Quilt a New Christmas with Piece O'Cake Designs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quilt a New Christmas with Piece O'Cake Designs
      </h1>
      <p class="bookDescription body article font2">
        <b>The bestselling design teams delivers “a fresh take on holiday colors and fun patterns for Christmas stockings, lap quilts, and wall hangings” (<i>The Applique Society Newsletter</i>).</b><br/><br/>Piece O’ Cake Designs fills your home with the Christmas spirit all year round! Half of these new designs give the holiday season a whimsical twist with unexpected fabrics and colors, and the other half are versatile and beautiful quilts that you can use even after the rest of your holiday decorations are packed away.<br/><br/>Projects include:Christmas in the ParkThe All Wonderful Red &amp; Green QuiltCaribbean ChristmasCircular MomentumA Treat Before Takeoff!The Stockings Were Hung by the Chimney with CarePerky Partridge Pincushion/Ornament<br/><br/><b>“Use the included full-size applique templates to create Christmas stockings, lap quilts, and wall hangings in the distinctive fresh and happy Piece O’ Cake style. Several of the quilt projects can be adapted for year-round use if made in different fabrics.” —<i>American Quilter</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Becky Goldsmith, Linda Jenkins
      </h2>
      
      <p class="authorDescription body article">Becky Goldsmith Bio: Becky Goldsmith is the co-owner of Piece O’ Cake Designs quilt patterns, as well as an award-winning quilter. Her art background and interior design degree provide a perfect alliance of insight and experience for quilting. She lives in Sherman, Texas. pieceocake.com   Linda Jenkins Bio: Linda Jenkins, best-selling author and celebrated quilt designer, is the other half of Piece O’ Cake Designs. She developed a fine eye for color as a hair colorist, makeup artist, and beauty shop owner, which influenced her appliqué patterns. She lives in Grand Junction, Colorado. pieceocake.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c42dffa0